import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CartContext } from 'components/cart';
import classNames from 'lib/classNames';

const OrderNote = (props) => {
	const { campaign, cart_settings, Utils, cartNote, setCartNote } = useContext(CartContext);
	const { order_note } = Utils.getModules(campaign, cart_settings);

	if (!order_note.active) return null;

	const handlChange = (event) =>{
		setCartNote(event.target.value)
	}

	return (
		<div className={classNames('py-3 px-5 adapt-images')}>
			<div
				dangerouslySetInnerHTML={{
					__html: order_note.text,
				}}
			></div>
			<textarea 
				value={cartNote || ""} 
				onChange={handlChange } 
				rows="4" 
				className={classNames('rounded  border-2 border-gray-300 w-full p-2')}// borderRadius: "5px"
				// style={{border: "1px #8c9196 solid", width: "100%",}}
			/>
		</div>
	);
};

OrderNote.propTypes = {};

export default OrderNote;
